
























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SwitchLocale extends Vue {
  @Prop({ default: 0 })
  value!: number;

  @Prop({ default: 0 })
  min!: number;

  @Prop(Number)
  max!: number;

  @Prop(String)
  label!: string;

  @Prop(String)
  tooltip!: string;

  add() {
    if (this.value < this.max) {
      this.input(this.value + 1);
    }
  }

  subtract() {
    if (this.value > this.min) {
      this.input(this.value - 1);
    }
  }

  @Emit()
  input(value: number) {
    return value;
  }
}
